class AudioPlayer {
  private static instance: AudioPlayer;
  private ringtoneAudio: HTMLAudioElement | null = null;
  private isPlaying: boolean = false;

  private constructor() {}

  public static getInstance(): AudioPlayer {
    if (!AudioPlayer.instance) {
      AudioPlayer.instance = new AudioPlayer();
    }
    return AudioPlayer.instance;
  }

  public async playRingtone(): Promise<void> {
    try {
      if (this.isPlaying) {
        return; // Already playing
      }

      // Create audio element if it doesn't exist
      if (!this.ringtoneAudio) {
        this.ringtoneAudio = new Audio("/assets/sounds/phone-ring.mp3");
        this.ringtoneAudio.loop = true;
        this.ringtoneAudio.volume = 0.7;
      }

      this.isPlaying = true;
      await this.ringtoneAudio.play();
    } catch (error) {
      console.error("Failed to play ringtone:", error);
      this.isPlaying = false;
    }
  }

  public stopRingtone(): void {
    if (this.ringtoneAudio && this.isPlaying) {
      this.ringtoneAudio.pause();
      this.ringtoneAudio.currentTime = 0;
      this.isPlaying = false;
    }
  }

  public isRingtonePlaying(): boolean {
    return this.isPlaying;
  }
}

export default AudioPlayer;
